const bool = (v: string | undefined, fallback = false): boolean => {
  if (v === undefined) return fallback
  return v === 'true' || v === '1'
}

const num = (v: string | undefined, fallback: number): number => {
  const n = Number(v)
  return Number.isNaN(n) ? fallback : n
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8080',
  bffUrl: import.meta.env.VITE_BFF_URL ?? 'http://localhost:8081',
  appEnv: (import.meta.env.VITE_APP_ENV ?? 'development') as 'development' | 'staging' | 'production',
  appName: import.meta.env.VITE_APP_NAME ?? 'OpenChambers',
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:3000',
  contactFormUrl: import.meta.env.VITE_CONTACT_FORM_URL ?? 'http://localhost:3000/contact',
  oidc: {
    issuer: import.meta.env.VITE_OIDC_ISSUER ?? '',
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? 'openchambers-web',
  },
  opik: {
    baseUrl: import.meta.env.VITE_OPIK_BASE_URL ?? 'https://www.comet.com/opik/api',
    project: import.meta.env.VITE_OPIK_PROJECT ?? 'openchambers-web',
  },
  features: {
    digitalCo: bool(import.meta.env.VITE_FF_DIGITAL_CO, true),
    aiConcierge: bool(import.meta.env.VITE_FF_AI_CONCIERGE, true),
    marketplace: bool(import.meta.env.VITE_FF_MARKETPLACE, true),
    matchmaking: bool(import.meta.env.VITE_FF_MATCHMAKING, true),
    dataPlatform: bool(import.meta.env.VITE_FF_DATA_PLATFORM, true),
    sreOps: bool(import.meta.env.VITE_FF_SRE_OPS, true),
  },
  pagination: {
    defaultPageSize: num(import.meta.env.VITE_DEFAULT_PAGE_SIZE, 20),
    maxPageSize: num(import.meta.env.VITE_MAX_PAGE_SIZE, 100),
  },
  cdn: {
    url: import.meta.env.VITE_CDN_URL ?? '',
    unsplashKey: import.meta.env.VITE_UNSPLASH_ACCESS_KEY ?? '',
  },
  allowIndexing: bool(import.meta.env.VITE_ALLOW_INDEXING, false),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const
